export const ARROW_AVAILABLE_POSITION = {
  LEFT: 'left',
  MIDDLE: 'middle',
  RIGHT: 'right',
}

export const ARROW_POSITIONS = [
  ARROW_AVAILABLE_POSITION.LEFT,
  ARROW_AVAILABLE_POSITION.MIDDLE,
  ARROW_AVAILABLE_POSITION.RIGHT,
]
